// extracted by mini-css-extract-plugin
export default {"main":"index_main_-tj05 clearfix w1000"};